module.exports = __webpack_public_path__ + "img/guide_03.0b66e5ad.png";